import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import {
  MDBSelect,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBValidation,
  MDBCardImage,
  MDBTextArea,
  MDBBtn,
  MDBInput,
  MDBBadge,
  div,
  MDBInputGroup,
} from "mdb-react-ui-kit";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import "../styles/fees.css";
import formatDate from "../utilities/dateFormat";
import fingerPrintServices from "../utilities/demo";
import Test from "./Test";
import CameraPopup from "../components/CameraPopup";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import validateTemplateBase64Data from "../utilities/validateTemplateBase64Data";
import API_BASE_URL from "../utilities/apiConfig";
import ScannerLoader from "../components/ScannerLoader";
import validatemembershipFeesFrom from "../utilities/validatemembershipFeesFrom";
import { useNavigate } from "react-router-dom";
import REPORT_BASE_URL from "../utilities/reportConfig";
import axiosInstance from "../utilities/apiConfig";
import getMembershipValidity from "../utilities/membershipValidity";
const Fees = () => {
  const [id, setId] = useState(0);
  const [barId, setbarId] = useState("");
  const [template1, setTemplate1] = useState("");
  const [template2, setTemplate2] = useState("");
  const [loading, setLoading] = useState(false);
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const [showFeesForm, setShowFeesForm] = useState(false);
  const [profileImage, setProfileImage] = useState(dummyProfileImage);
  const [signatureImage, setSignatureImage] = useState(dummySignature);
  const [imageSrc1, setImageSrc1] = useState(dummyFingerprint);
  const [refresh, setRefresh] = useState(0);
  const [isFeeSlipPrintable, setIsFeeSlipPrintable] = useState(false);
  const [imageSrc2, setImageSrc2] = useState(dummyFingerprint);
  const [fingerPrintDB, setFingerPrintDB] = useState(false);
  const [fingerPrintFees, setFingerPrintFees] = useState(false);
  const [fingerPrintScanMessage, setFingerPrintScanMessage] = useState(true);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const [feesBookAndSerialNo, setFeesBookAndSerialNo] = useState({
    upcomingBookNo: 0,
    upcomingSerialNo: 0,
  });
  const [feesDetails, setFeesDetails] = useState("");
  const [feesValidity, setFeesVaidity] = useState("");
  // Yearly fee session status from /LoginFees/check_fees_session
  const [feesSession, setFeesSession] = useState(null);
  // Session being paid (yearly only): 1 = previous, 2 = current (sent as mode)
  const [paymentMode, setPaymentMode] = useState(2);
  // Entered by the operator; required for previous session after 31 Dec
  const [penaltyAmount, setPenaltyAmount] = useState("");
  // Renewal/Verification (welfare) status, view only on this page.
  const [renewalStatus, setRenewalStatus] = useState(null);
  const baseURL = axiosInstance.defaults.baseURL;

  const initialUserData = {
    verificationId: "",
    name: "",
    relationshipType: "S/O",
    relativeName: "",
    barAssociationId: "",
    concernedBarRegistrationDate: "",
    dateOfBirth: "",
    advocateBarId: "",
    mobileNo: "",
    email: "",
    experienceIn: "",
    yearsOfExperience: "",
    permanentAddress: "",
    localAddress: "",
    advocacyDocuments: "",
    enrollmentNo: "",
    enrollmentCertificate: "",
    aibePassCertificateNo: "",
    aibePassCertificate: "",
    copNo: "",
    copCertificate: "",
    copValitidy: "",
    aadharCertificate: "",
    isAnotherBarMember: "",
    barAssociationMembershipDetails: "",
    mentorAdvocateName: "",
    mentorAdvocateBarId: "",
    joiningDate: "",
    chamberNo: "",
    photo: "",
    fingerprint: "",
    signature: "",
    verificationDate: "",
    status: "",
  };

  const initalFeesFormData = {
    advocateBarId: "",
    membershipTypeId: "",
    feesAmount: "",
    userId: "",
    upcomingBookNo: 0,
  };

  const [feesFormData, setFeesFormData] = useState(initalFeesFormData);
  const [userData, setUserData] = useState(initialUserData);
  const fingerPrintService = fingerPrintServices();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  const handleVerifyFingerPrint = async (fingerprint2) => {
    try {
      setLoading(true);
      console.log("finger print data from fees page ", fingerPrintFees);
      console.log("finger print data from db", fingerPrintDB);
      var data1Validation = validateTemplateBase64Data(fingerPrintDB);
      var data2Validation = validateTemplateBase64Data(fingerprint2);
      if (data2Validation && data1Validation) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerPrintDB,
          fingerprint2,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);
        if (response.matched) {
          toast.success("Fingerprint verified ");
          dispatch(clearImageData());
          setFingerPrintScanMessage(false);
        } else if (!response.matched) {
          toast.error("Finger Print Does Not Matched");
          setFingerPrintScanMessage(true);
        }
      } else {
        toast.warning("Please Scan Your FingerPrint");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error : Fingerprint  Not Verified Please try again");
      // Handle the error here
    } finally {
      setLoading(false);
    }
  };

  const imageData = useSelector((state) => state.profileimage?.imageData);
  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  console.log("image data of fees page", imageData);

  const containerStyle = {
    display: "flex",
    width: "100%",
  };

  const columnStyle = {
    flex: 1,
    textAlign: "center",
  };

  const handleGetUpcomingBookNoAndSerialNo = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/LoginFees/get_upcoming_book_no_and_serial_no_for_fees`,
        {
          headers: {
            accept: "*/*",
          },
        }
      );

      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        const { upcomingBookNo, upcomingSerialNo } = response.data;
        console.log(upcomingBookNo, upcomingSerialNo);
        setFeesBookAndSerialNo({ upcomingBookNo, upcomingSerialNo });
        setFeesFormData((prevState) => ({ ...prevState, upcomingBookNo }));
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      console.log("Error from upcoming book no and serial no", error);
      toast.error("An Unexpected error occured while ");
    } finally {
      setLoading(false);
      console.log(feesBookAndSerialNo);
      setRefresh(refresh + 1);
    }
  };

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    console.log(feesBookAndSerialNo);

    setUserData({
      ...userData,
      [name]: value,
    });

    setFeesFormData({
      ...feesFormData,
      [name]: value,
    });

    console.log("Handle Input Field Change", "=>", name, " : ", value);
  };

  // usp_MembershipFees_CheckAdvocate: PAY_PREVIOUS (paymentMode 1), PAY_CURRENT (2),
  // ALREADY_PAID_CURRENT, LIFETIME. penaltyRequired = previous session after 31 Dec.
  const fetchFeesSession = async (formatted_bar_id) => {
    const response = await axiosInstance.get(
      `/LoginFees/check_fees_session/${formatted_bar_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Fees session check response", response.data);
    setFeesSession(response.data);
    setPaymentMode(response.data?.paymentMode === 1 ? 1 : 2);
    setPenaltyAmount("");
    return response.data;
  };

  const handleGetAdvocateFeesVerificationData = async () => {
    try {
      setLoading(true);
      setFingerPrintScanMessage(true);
      setIsFeeSlipPrintable(false);
      setShowFeesForm(false);
      setFeesSession(null);
      setPaymentMode(2);
      setPenaltyAmount("");
      setRenewalStatus(null);

      setUserData(initialUserData);
      if (barId !== null) {
        const formatted_bar_id = convertToUnderscoreFormat(barId);
        console.log(formatted_bar_id);

        // Yearly fee session (previous / current + penalty); a failure here should not block fees.
        try {
          const session = await fetchFeesSession(formatted_bar_id);
          if (session?.resultCode === "PAY_PREVIOUS") {
            toast.warning(session.message);
          }
        } catch (error) {
          console.error("Error fetching fees session status:", error);
          toast.warning(
            "Could not load yearly fee session (previous/current). Please restart the API."
          );
        }

        // Renewal/Verification validity; a failure here should not block fees.
        try {
          const checkResponse = await axiosInstance.get(
            `/Welfare/check_advocate/${formatted_bar_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const { resultCode, message, validTill } = checkResponse.data;
          setRenewalStatus({ resultCode, message, validTill });
        } catch (error) {
          console.error("Error fetching renewal status:", error);
        }
        const response = await axiosInstance.get(
          `/Verification/${formatted_bar_id}`
        );
        console.log("Verifiaction data for Bar Id", response.data);
        setUserData(response.data.advocateDetails);
        console.log(response.data.advocateDetails?.advocateBarId);
        setFeesDetails(response.data?.feesdetails);
        if (
          response.data?.feesdetails?.feesStatusCode === 202 &&
          response.data?.feesvalidity
        ) {
          setFeesVaidity(response.data?.feesvalidity);
        } else if (response.data?.feesdetails?.feesStatusCode === 200) {
          setFeesVaidity("LifeTime");
        } else {
          setFeesVaidity("Not Submitted");
        }
        setFeesFormData({
          ...feesFormData,
          advocateBarId: response.data.advocateDetails?.advocateBarId,
        });
        console.log(response.data.advocateDetails?.fingerprintData);
        setFingerPrintDB(response.data.advocateDetails?.fingerprintData);

        //COMMENT BY KHALID STARTS

        // setProfileImage(
        //   `${baseURL}/Verification/${response.data?.advocateDetails?.photo}` ||
        //     dummyProfileImage
        // );
        // setSignatureImage(
        //   `${baseURL}/Verification/${response.data?.advocateDetails?.signature}` ||
        //     dummyProfileImage
        // );
        // setImageSrc2(
        //   `${baseURL}/Verification/${response.data?.advocateDetails?.fingerprintImage}` ||
        //     dummyProfileImage
        // );

        // COMMENT BY KHALID ENDS

        // CHANGES MADE BY KHALID STARTS

        const imageUrl = `/Verification/${response.data?.advocateDetails?.photo}`;

        try {
          const response = await axiosInstance.get(imageUrl, {
            responseType: "blob", // Important for image fetching
          });

          const imageBlob = URL.createObjectURL(response.data); // Create a URL for the blob
          setProfileImage(imageBlob); // Set the image state
        } catch (error) {
          console.error("Error fetching profile image:", error);
          setProfileImage(dummyProfileImage); // Fallback to dummy image on error
        }

        // Fetch and set the signature image
        const signatureImageUrl = `/Verification/${response.data?.advocateDetails?.signature}`;

        try {
          const signatureResponse = await axiosInstance.get(signatureImageUrl, {
            responseType: "blob", // Important for image fetching
          });

          const signatureBlob = URL.createObjectURL(signatureResponse.data); // Create a URL for the blob
          setSignatureImage(signatureBlob); // Set the signature image state
        } catch (error) {
          console.error("Error fetching signature image:", error);
          setSignatureImage(dummySignature); // Fallback to dummy signature on error
        }

        // Fetch and set the fingerprint image
        const fingerprintImageUrl = `/Verification/${response.data?.advocateDetails?.fingerprintImage}`;

        try {
          const fingerprintResponse = await axios.get(fingerprintImageUrl, {
            responseType: "blob", // Important for image fetching
          });

          const fingerprintBlob = URL.createObjectURL(fingerprintResponse.data); // Create a URL for the blob
          setImageSrc2(fingerprintBlob); // Set the fingerprint image state
        } catch (error) {
          console.error("Error fetching fingerprint image:", error);
          setImageSrc2(dummyFingerprint); // Fallback to dummy fingerprint on error
        }

        // CHANGES MADE BY KHALID ENDS

        // setProfileImage(response.data.advocateDetails?.photo || dummyProfileImage);
        // setSignatureImage(response.data.advocateDetails?.signature || dummySignature);
        // setImageSrc2(response.data.advocateDetails?.fingerprintImage || dummyFingerprint)
        if (response.data.response.statusCode === 200) {
          toast.success("Please Verify Your Details");

          handleGetUpcomingBookNoAndSerialNo();
          setShowFeesForm(true);
        } else {
          toast.error(response.data.response.status);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitFees = async (e) => {
    e.preventDefault();
    console.log("sending the fees form data", feesFormData);
    const validationErrors = validatemembershipFeesFrom(feesFormData);
    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
    } else if (
      isYearlySelected &&
      feesSession?.paymentMode === 1 &&
      paymentMode !== 1
    ) {
      toast.error(
        "Previous session yearly fee is not paid. Please pay the previous session first."
      );
    } else if (isPenaltyNeeded && !(Number(penaltyAmount) > 0)) {
      toast.error("Please enter the penalty amount (after 31 Dec).");
    } else {
      if (!fingerPrintScanMessage) {
        const paidPreviousSession = isYearlySelected && paymentMode === 1;
        try {
          setLoading(true);

          const payload = {
            ...feesFormData,
            // yearly only: 1 = previous session, 2 = current session
            mode: isYearlySelected ? paymentMode : 2,
            penaltyAmount: isPenaltyNeeded ? Number(penaltyAmount) : 0,
          };
          console.log("fees form data", payload);

          const response = await axiosInstance.post(
            `/LoginFees/fees_post_with_provided_book_no`,
            payload,
            {
              headers: {
                "Content-Type": "application/problem+json; charset=utf-8",
                Authorization: `Bearer ${token}`, // Include the token in the request header
              },
            }
          );
          console.log(response.data);
          if (response.data.statusCode === 200) {
            toast.success(response.data.status);
            setIsFeeSlipPrintable(true);

            // After the previous session is paid, the current session becomes
            // payable: keep the form open for it instead of closing.
            let keepFormOpen = false;
            if (paidPreviousSession) {
              try {
                const session = await fetchFeesSession(
                  convertToUnderscoreFormat(barId)
                );
                if (session?.resultCode === "PAY_CURRENT") {
                  keepFormOpen = true;
                  toast.info(
                    "Previous session paid. Now pay the current session."
                  );
                }
              } catch (error) {
                console.log("Error refreshing fees session status", error);
              }
            }
            if (!keepFormOpen) {
              setShowFeesForm(false);
            }
          } else if (response.data.statusCode === 201) {
            toast.error(response.data.status);
            setIsFeeSlipPrintable(true);
            setShowFeesForm(false);
          } else {
            toast.error(response.data.status);
          }
        } catch (error) {
          if (error.response) {
            toast.error(error.response.data.status);
          } else {
            toast.error("An error occurred");
          }
          console.log("Fees Api Error", error);
        } finally {
          setLoading(false);
          // Keep bar id / user id / book no so the current session can be paid next.
          setFeesFormData((prev) => ({
            ...initalFeesFormData,
            advocateBarId: prev.advocateBarId,
            userId: prev.userId,
            upcomingBookNo: prev.upcomingBookNo,
          }));
          setPenaltyAmount("");
        }
      } else {
        toast.warning("Please verify fingerprint");
      }
    }
  };

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (result.ErrorCode === 0) {
      if (result != null && result.BMPBase64.length > 0) {
        setTemplate2(result.TemplateBase64);
        setFingerPrintFees(result.TemplateBase64);
        setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
        handleVerifyFingerPrint(result.TemplateBase64);
      }
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
      console.log("Finger print error in fee page ", result);
      // alert(`Fingerprint Capture Error Code: ${result.ErrorCode}.\nDescription: ${errorCodeToString(result.ErrorCode)}.`);
    }
  };

  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");

    // alert(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  const callSGIFPGetData = (successCall, failCall) => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        successCall(data);
      })
      .catch((error) => {
        failCall(error);
      });
  };

  const matchScore = (succFunction, failFunction) => {
    if (template1 === "" || template2 === "") {
      alert("Please scan two fingers to verify!!");
      return;
    }
    const uri = "https://localhost:8000/SGIMatchScore";

    const params = `template1=${encodeURIComponent(
      template1
    )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        succFunction(data);
      })
      .catch((error) => {
        failFunction(error);
      });
  };

  const succMatch = (result) => {
    const idQuality = quality;
    if (result.ErrorCode === 0) {
      if (result.MatchingScore >= idQuality) {
        toast.success(`FingerPrint Matched Successfully`);
        //alert(`MATCHED ! (${result.MatchingScore})`);
      } else {
        toast.error("Not Matched Try Again");
        //alert(`NOT MATCHED ! (${result.MatchingScore})`);
      }
    } else {
      toast.error("Error Scanning Fingerprint");
      //alert(`Error Scanning Fingerprint ErrorCode = ${result.ErrorCode}`);
    }
  };

  const failureFunc = (error) => {
    alert("On Match Process, failure has been called");
  };

  const errorCodeToString = (ErrorCode) => {
    // Implement the ErrorCodeToString function here
  };

  const navigate = useNavigate();

  // Previous / current session applies to Yearly fees only.
  const isYearlySelected = feesFormData?.membershipTypeId === "1";
  const membershipValidityInfo = getMembershipValidity(
    feesSession,
    feesDetails,
    feesValidity
  );
  const isPenaltyNeeded =
    isYearlySelected && paymentMode === 1 && !!feesSession?.penaltyRequired;
  const totalWithPenalty =
    (Number(feesFormData?.feesAmount) || 0) +
    (isPenaltyNeeded ? Number(penaltyAmount) || 0 : 0);
  // penaltyFrom = 1 Jan of the current session; the deadline is the day before (31 Dec).
  const penaltyDeadlineYear = feesSession?.penaltyFrom
    ? new Date(feesSession.penaltyFrom).getFullYear() - 1
    : "";

  useEffect(() => {
    setFeesFormData({
      ...feesFormData,
      userId: userDeatils?.userId,
      upcomingBookNo: feesBookAndSerialNo?.upcomingBookNo,
    });

    console.log("User Id and book No From Login Session", feesFormData.userId);
  }, [refresh]);

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <div className="row justify-content-center mb-2">
        <div className="col-xxl-8 mt-5 d-flex justify-content-end">
          <MDBBtn
            style={{ backgroundColor: "#60a0ff", borderColor: "#60a0ff" }}
            onClick={() => {
              navigate("/WelfareFees");
            }}
          >
            Renewal/Verification Fees
          </MDBBtn>
        </div>
      </div>

      <div className="row justify-content-center mb-2">
        <div className="col-xxl-8 mt-5">
          <h3 className="text-center mb-5 ">
            <b>Membership Fees Submition</b>
          </h3>
        </div>
      </div>

      <div className="row justify-content-center mb-5">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <div
              feedback="Please Enter Bar Id."
              invalid
              className="col-md-6 col-xl-4 col-xxl-3 mb-1 d-flex"
            >
              <MDBInput
                required
                value={barId}
                onChange={(e) => setbarId(e.target.value)}
                label="Enter Bar Id"
                type="text"
                name="barId"
                className="m-0"
                id="barId"
              />
            </div>

            <div className="col-md-6 col-xl-5 col-xxl-4 mb-1">
              <MDBBtn
                onClick={() => {
                  handleGetAdvocateFeesVerificationData();
                }}
              >
                Get Data
              </MDBBtn>{" "}
              {/* &nbsp;
              <MDBBtn
                color="success"
                onClick={() => {
                  navigate(`/FeesDetails`);
                }}
              >
                Table
              </MDBBtn>{" "}
              &nbsp; */}
              <MDBBtn
                color="warning"
                onClick={() => {
                  if (!barId) {
                    toast.warning("Please enter Bar Id");
                    return;
                  }
                  navigate(`/FeesSlip/${convertToUnderscoreFormat(barId)}`);
                }}
              >
                Print Fees Slip
              </MDBBtn>
            </div>
          </div>
        </div>
      </div>

      <div className="row p-3 mt-4 justify-content-center ">
        {showFeesForm && (
          <>
            <div className="row justify-content-center mb-3">
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Enter Name"
                  id="name"
                  name="name"
                  value={userData?.name}
                  readOnly
                  type="text"
                />
              </div>

              <div className="col-sm-6 col-md-3 col-xxl-2">
                <div className="input-group mb-3">
                  <select
                    className="form-select form-select-sm py-0"
                    style={{
                      height: "calc(1.5em + 0.75rem + 2px)",
                      width: "35%",
                    }}
                    value={userData?.relationshipType}
                    disabled
                    name="relationshipType"
                    id="relationshipType"
                  >
                    <option value="Son">S/O</option>
                    <option value="Daughter">D/O</option>
                    <option value="Wife">W/O</option>
                  </select>

                  <div className="input-group-append" style={{ width: "65%" }}>
                    <MDBInput
                      label="Relative Name"
                      id="relativeName"
                      name="relativeName"
                      value={userData?.relativeName}
                      readOnly
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Date of Birth"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={userData?.dateOfBirth}
                  readOnly
                  type="date"
                />
              </div>
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Phone No"
                  id="mobileNo"
                  name="mobileNo"
                  value={userData?.mobileNo}
                  readOnly
                  type="text"
                />
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label" for="subscription__type">
                      Subscription Type
                    </label>

                    <select
                      className="form-select"
                      onChange={handleInputFieldChange}
                      value={feesFormData?.membershipTypeId}
                      name="membershipTypeId"
                      id="membershipTypeId"
                    >
                      <option value="" selected>
                        Select
                      </option>
                      <option className="mb-3" value="1">
                        Yearly
                      </option>
                      <option className="mb-3" value="2">
                        LifeTime
                      </option>
                      <option className="bg-danger text-white mb-3" value="4">
                        Cancel
                      </option>
                    </select>
                  </div>

                  <div className="col-md-3 mt-auto d-flex">
                    <MDBInput
                      onChange={handleInputFieldChange}
                      value={feesFormData?.feesAmount}
                      name="feesAmount"
                      className="mb-0 d-inline"
                      id="feesAmount"
                      label="Total Amount in ₹"
                      type="number"
                      required
                    />
                  </div>
{/* 
                  <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                    <label className="form-label" for="subscription__type">
                      Upcoming Book No & Serial No
                    </label>
                    <div>
                      <div className="input-group" style={containerStyle}>
                        <input
                          value={feesFormData?.upcomingBookNo}
                          className="form-control"
                          readOnly={feesBookAndSerialNo?.upcomingSerialNo !== 1}
                          onChange={(e) => {
                            setFeesFormData({
                              ...feesFormData,
                              upcomingBookNo: e.target.value,
                            });
                          }}
                          style={columnStyle}
                          type="number"
                        />
                        <div className="input-group-append" style={columnStyle}>
                          <span className="input-group-text">
                            {feesBookAndSerialNo?.upcomingSerialNo}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                    <strong>Membership Validity : </strong>
                    <span
                      className={`badge rounded-pill ${
                        membershipValidityInfo.isValid ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {membershipValidityInfo.text}
                    </span>
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                    <strong>Renewal/Verification Valid Till : </strong>
                    <span
                      className={`badge rounded-pill ${
                        renewalStatus?.resultCode === "ALREADY_PAID_CURRENT"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {renewalStatus?.validTill
                        ? new Date(renewalStatus.validTill).toLocaleDateString(
                            "en-GB"
                          )
                        : "Not Submitted"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {feesSession?.resultCode && (
              <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                  <div className="mb-1">
                    <strong>Yearly Fee Session : </strong>
                    <span
                      className={`badge rounded-pill ${
                        feesSession.resultCode === "PAY_PREVIOUS"
                          ? "bg-danger"
                          : feesSession.resultCode === "PAY_CURRENT"
                          ? "bg-warning text-dark"
                          : "bg-success"
                      }`}
                    >
                      {feesSession.resultCode === "PAY_PREVIOUS" &&
                        `Previous Session Due (${feesSession.previousSession})`}
                      {feesSession.resultCode === "PAY_CURRENT" &&
                        `Current Session Due (${feesSession.currentSession})`}
                      {feesSession.resultCode === "ALREADY_PAID_CURRENT" &&
                        `Paid for ${feesSession.currentSession}`}
                      {feesSession.resultCode === "LIFETIME" && "Lifetime Member"}
                    </span>
                  </div>

                  {isYearlySelected &&
                    (feesSession.resultCode === "PAY_PREVIOUS" ||
                      feesSession.resultCode === "PAY_CURRENT") && (
                      <>
                        <label className="form-label me-3">
                          <strong>Payment For :</strong>
                        </label>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="feesPaymentMode"
                            id="feesPaymentModePrevious"
                            value="1"
                            checked={paymentMode === 1}
                            disabled={feesSession.paymentMode !== 1}
                            onChange={() => setPaymentMode(1)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="feesPaymentModePrevious"
                          >
                            Previous Session ({feesSession.previousSession})
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="feesPaymentMode"
                            id="feesPaymentModeCurrent"
                            value="2"
                            checked={paymentMode === 2}
                            disabled={feesSession.paymentMode === 1}
                            onChange={() => setPaymentMode(2)}
                          />
                          <label
                            className="form-check-label" 
                            htmlFor="feesPaymentModeCurrent"
                          >
                            Current Session ({feesSession.currentSession})
                          </label>
                        </div>

                        {feesSession.paymentMode === 1 && (
                          <div
                            className={`small mt-1 ${
                              feesSession.penaltyRequired
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            {feesSession.penaltyRequired
                              ? `31 Dec ${penaltyDeadlineYear} has passed: previous session fee must be paid with penalty. Pay it first, then the current session.`
                              : `No penalty till 31 Dec ${penaltyDeadlineYear}. Pay the previous session first, then the current session.`}
                          </div>
                        )}

                        {isPenaltyNeeded && (
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <MDBInput
                                value={penaltyAmount}
                                onChange={(e) => setPenaltyAmount(e.target.value)}
                                name="penaltyAmount"
                                id="penaltyAmount"
                                label="Penalty Amount in ₹"
                                type="number"
                                min="1"
                                required
                              />
                            </div>
                            <div className="col-md-4 mt-auto">
                              <strong>Total to collect : </strong>₹
                              {totalWithPenalty}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                </div>
              </div>
            )}

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div data-mdb-input-init className="form-outline">
                  <label className="form-label" htmlFor="textAreaExample3">
                    Permanent Address
                  </label>
                  <MDBTextArea
                    className="form-control"
                    id="permanentAddress"
                    name="permanentAddress"
                    value={userData?.permanentAddress}
                    readOnly
                    rows="2"
                  ></MDBTextArea>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                {fingerPrintScanMessage ? (
                  <div className="text-danger">
                    Please verify your fingerprint before fees form submission
                  </div>
                ) : (
                  <div className="text-success">
                    Your fingerprint is verified Please submit your fees form{" "}
                  </div>
                )}
              </div>
            </div>

            <div className="row justify-content-center my-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={profileImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Photo
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn
                          onClick={() =>
                            callSGIFPGetData(successFunc2, errorFunc)
                          }
                        >
                          +
                        </MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={imageSrc2}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Fingerprint
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={signatureImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>

                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Signature
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center my-5">
              <div className="col-md-2 mb-1">
                <MDBBtn
                  onClick={(e) => {
                    handleSubmitFees(e);
                  }}
                >
                  Submit
                </MDBBtn>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Fees;
